import React from "react";

type TheorySectionProps = {
  title?: string;
  paragraphs: string[];
  image: string;        // already imported image
  imageAlt?: string;
};

const TheorySection: React.FC<TheorySectionProps> = ({
  title,
  paragraphs,
  image,
  imageAlt = "Theory Illustration",
}) => {
  return (
    <section className="pt-80 pb-80">
      <div className="container">

        {/* OPTIONAL TITLE */}
        {title && (
          <h2 className="xb-section-title text-center wow fadeInUp mb-60">
            {title}
          </h2>
        )}

        <div className="row align-items-start">

          {/* LEFT IMAGE */}
          <div
            className="col-lg-5 col-md-12 wow fadeInLeft"
            data-wow-delay="100ms"
          >
            <img
              src={image}
              alt={imageAlt}
              style={{
                width: "100%",
                borderRadius: "18px",
                objectFit: "cover",
              }}
            />
          </div>

          {/* RIGHT ARTICLE CONTENT */}
          <div
            className="col-lg-7 col-md-12 wow fadeInUp"
            data-wow-delay="200ms"
            style={{
              paddingLeft: "50px", // ⬅️ subtle right shift (premium feel)
            }}
          >
            {paragraphs.map((text, index) => (
              <p
                key={index}
                style={{
                  fontSize: "19px",
                  lineHeight: "1.9",
                  color: "rgba(255,255,255,0.9)",
                  marginBottom:
                    index !== paragraphs.length - 1 ? "32px" : 0,
                }}
              >
                {text}
              </p>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default TheorySection;
